import { memo } from "react";
import moment from "moment";

import {
    ReportChartSeries,
    ReportItemType,
    ReportTimeRangeType,
} from "types/Reports";

import { getTitleByTime } from "./utils/reportString";

import ReportTabListItem from "./ReportTabListItem";

type ReportTabListProps = {
    timeRangeType: ReportTimeRangeType;
    itemType: ReportItemType;

    isLoading: boolean;

    chartSeries: ReportChartSeries[];
    prevChartSeries: ReportChartSeries[];

    categories: string[];
    time: moment.Moment;

    dateFormat: string;
    highlightClassName: string;
    color: string;
};

export default memo(function ReportTabList({
    timeRangeType,
    itemType,

    isLoading,

    chartSeries,
    prevChartSeries,

    categories,
    time,

    dateFormat,
    highlightClassName,
    color,
}: Readonly<ReportTabListProps>) {
    const titleTimeText = getTitleByTime(timeRangeType);

    return (
        <section className="d-block w-100 report-main-section">
            <section className="d-flex w-100 m-0 p-0 report-tab-chart-container">
                {chartSeries.map((itemSeries) => {

                    const previousSeries = prevChartSeries.find((item) => item.id === itemSeries.id);
                    return <ReportTabListItem
                        key={`report-tab-list-${itemType}-${itemSeries.id}`}
                        curSeries={itemSeries}
                        prevSeries={previousSeries}

                        isLoading={isLoading}

                        timeRangeType={timeRangeType}
                        itemType={itemType}

                        categories={categories}
                        time={time}

                        dateFormat={dateFormat}
                        titleTimeText={titleTimeText}

                        highlightClassName={highlightClassName}
                        color={color}
                    />;
                })}
            </section>
        </section>
    );
});
